module.exports = __webpack_public_path__ + "media/images/ioscor-0aa33496a3d1414e3101a74891725e98.jpg";